import LessonSlide from './LessonSlide';

export default LessonSlide;
